import React, { useEffect, useState } from 'react'
import DepartmentMaster from './Department/DepartmentMaster'
import SupplierMaster from './Supplier/SupplierMaster';
import EmployeeMaster from './Employee/EmployeeMaster';
import $ from 'jquery';
import useFetch from '../hooks/useFetch';
import { getMasterEditEmpSuccess, start } from '../store/slices/TeamManagementSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
// import Nav from './Nav'
// import SideMenu from './SideMenu'
// import Tabs from 'react-bootstrap/Tabs';
// import Tab from 'react-bootstrap/Tab';


export default function TeamManagement() {
  const [activeTab, setActiveTab] = useState("department");
  const { data } = useFetch('master/edit/employee')
  const { state } = useLocation();
  const dispatch = useDispatch();

  if (data && Object.keys(data).length > 0) {
    dispatch(getMasterEditEmpSuccess(data));
  } else (
    dispatch(start())
  )

  useEffect(() => {
    if (state && state !== '' && state !== activeTab) {
      setActiveTab(state);
    }
  }, []);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  return (
    <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 className="h2">Team Management</h1>
      </div>

      <nav>
        <div className="nav nav-tabs team-mngmt-tab" id="nav-tab" role="tablist">
          <button
            className={`nav-link ${activeTab === 'department' ? 'active' : ''}`}
            id="nav-department-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="nav-department"
            aria-selected={activeTab === 'department'}
            onClick={() => toggleTab('department')}
          >
            <b>Department Master</b>
          </button>
          <button
            className={`nav-link ${activeTab === 'employee' ? 'active' : ''}`}
            id="nav-employee-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="nav-employee"
            aria-selected={activeTab === 'employee'}
            onClick={() => toggleTab('employee')}
          >
            <b>Employee Master</b>
          </button>
          <button
            className={`nav-link ${activeTab === 'supplier' ? 'active' : ''}`}
            id="nav-supplier-tab"
            data-bs-toggle="tab"
            type="button"
            role="tab"
            aria-controls="nav-supplier"
            aria-selected={activeTab === 'supplier'}
            onClick={() => toggleTab('supplier')}
          >
            <b>Supplier Master</b>
          </button>
          
        </div>
      </nav>

      <div className="tab-content" id="nav-tabContent">
        <div
          className={`tab-pane fade ${activeTab === 'department' ? 'show active' : ''}`}
          id="nav-department"
          role="tabpanel"
          aria-labelledby="nav-department-tab"
        >
          <DepartmentMaster />
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'employee' ? 'show active' : ''}`}
          id="nav-employee"
          role="tabpanel"
          aria-labelledby="nav-employee-tab"
        >
          <EmployeeMaster />
        </div>
        <div
          className={`tab-pane fade ${activeTab === 'supplier' ? 'show active' : ''}`}
          id="nav-supplier"
          role="tabpanel"
          aria-labelledby="nav-supplier-tab"
        >
          <SupplierMaster />
        </div>
      </div>
    </main>
  );


}
